import PropTypes from 'prop-types'
import NotificationField from './NotificationField'
import PulseEstimationResult from './PulseEstimationResult/PulseEstimationResult'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

const ResponseField = ({ consumption }) => {
  const isPulse = usePulseScope()

  if (!consumption || Object.entries(consumption).length === 0) {
    return
  }

  if (isPulse) {
    return (
      <PulseEstimationResult
        carBase={consumption?.car_elec_base}
        carHp={consumption?.car_elec_hp}
        carHc={consumption?.car_elec_hc}
        carGas={consumption?.car_gas}
      />
    )
  }

  return (
    <NotificationField
      carBase={consumption?.car_elec_base}
      carHp={consumption?.car_elec_hp}
      carHc={consumption?.car_elec_hc}
      carGas={consumption?.car_gas}
    />
  )
}

ResponseField.propTypes = {
  consumption: PropTypes.object,
}

export default ResponseField
